import { Component } from '@angular/core';

@Component({
  selector: 'app-typebedroom-extends',
  templateUrl: './typebedroom-extends.component.html',
  styleUrls: ['./typebedroom-extends.component.css']
})
export class TypebedroomExtendsComponent {

}
